import { fetchMarketingId } from "@origin-digital/event-dispatcher";
import { updateFullStoryWithBrazeId } from "./fs";

export async function initFullStory() {
  // Get brazeId from fetchMarketingId
  const { bzid } = (await fetchMarketingId({})) || {};
  updateFullStoryWithBrazeId(bzid);
}
